import { Box, Dialog, DialogContentContainer, Flex, TextField } from '@vibe/core';
import { offset, shift } from '@floating-ui/react-dom';
import { HighlightColorBucket } from '@vibe/icons';
import { HexColorPicker } from 'react-colorful';

type ColorSettingProps = {
  color?: string;
  label?: string;
  placeholder?: string;
  onChange: (newColor: string) => void;
};

// The picker is anchored to the whole field, label included. Opening above, it would sit over the label, well away from
// the input; subtract the label height so it's as close to the input as when it opens below.
const colorPickerOffset = offset(({ placement, elements }) => {
  const reference = elements.reference;
  const input = reference instanceof Element ? reference.querySelector('input') : null;
  const labelHeight =
    placement.startsWith('top') && input && reference instanceof Element
      ? input.getBoundingClientRect().top - reference.getBoundingClientRect().top
      : 0;

  return { mainAxis: 10 - labelHeight, crossAxis: 15 };
});

export function ColorSetting({ color, label, placeholder = 'e.g. #cccccc', onChange }: ColorSettingProps) {
  return (
    <Dialog
      middleware={[colorPickerOffset, shift({ mainAxis: false })]}
      tooltipClassName="colorpicker__tooltip"
      tooltip
      shouldShowOnMount={false}
      showTrigger={['click']}
      hideTrigger={['clickoutside']}
      position="bottom-end"
      onDialogDidShow={() => null}
      onDialogDidHide={() => null}
      content={
        <DialogContentContainer type="popover" size="large" className="colorpicker__dialog">
          <Flex gap={24}>
            <HexColorPicker color={color} onChange={onChange} />
          </Flex>
        </DialogContentContainer>
      }
    >
      <Box style={{ position: 'relative' }}>
        <TextField
          value={color}
          size="medium"
          title={label}
          placeholder={placeholder}
          className="colorpicker__wrapper--textfield"
          icon={HighlightColorBucket}
          onChange={(value: any) => {
            onChange(value);
          }}
        />
        <Box
          style={{
            pointerEvents: 'none',
            overflow: 'hidden',
            zIndex: 100,
            position: 'absolute',
            bottom: '13px',
            left: '12px',
            width: '12px',
            height: '12px',
            backgroundColor: color,
            borderRadius: '100%',
            border: '1px solid #ccc',
            lineHeight: 0,
          }}
        />
      </Box>
    </Dialog>
  );
}
